import {
	AppDescription,
} from '@local_types/index';
import {
	buildUrl,
} from '@stonal-tech/lib-front-utils-ts';
import {
	URL_PATTERNS,
} from '../../config/urlPatterns';

export const getIdentApiUrl = (app: AppDescription): string => buildUrl(URL_PATTERNS.IDENT_API, {
	env: app.env,
	stack: app.stack,
	// providerDomain will be auto-detected by buildUrl if not provided
});
